module.exports = __webpack_public_path__ + "img/9cf8e18.png";